import { render } from "./HomeTrammellTech.vue?vue&type=template&id=dc580632&ts=true"
import script from "./HomeTrammellTech.vue?vue&type=script&lang=ts"
export * from "./HomeTrammellTech.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__